import DefaultContent from "./content/DefaultContent";
import React from "react";

const WithDefaultWrapper = ({ title, children }) =>
  title ? <DefaultContent title={title}>{children}</DefaultContent> : children;

export default WithDefaultWrapper;
